type ThemeOverrideLike =
  | {
      product_id?: string | null
      m3_product_id?: string | null
    }
  | null
  | undefined

export const getThemeOverrideProductId = (
  themeOverride: ThemeOverrideLike,
): string | null =>
  themeOverride?.product_id ?? themeOverride?.m3_product_id ?? null
